if(!customElements.get('blog-posts')){
    class BlogPosts extends HTMLElement {
        constructor(){
            super();

            this.id = this.dataset.id;
        }

        connectedCallback(){
            this.onLoadPaginationSubscriber = PubSub.subscribe(PubSub.events.onLoadPagination, this.handleBlogPostsLoad.bind(this));
            this.onLoadNumberPaginationSubscriber = PubSub.subscribe(PubSub.events.onLoadNumberPagination, this.handleBlogPostsLoadByNumber.bind(this));
        }

        disconnectedCallback(){
            if(this.onLoadPaginationSubscriber && typeof this.onLoadPaginationSubscriber === 'function'){
                this.onLoadPaginationSubscriber();
            }
        }

        handleBlogPostsLoadByNumber({ data, callback }){
            if(data.type !== 'article') return;

            this.pendingRequestUrl = data.url;
            const currentUrl = data.url || this.pendingRequestUrl;

            setTimeout(() => {
                this.renderContent({
                    requestUrl: `${currentUrl}`,
                    callback: this.loadBlogPostsContentByNumber({
                        callback: callback
                    })
                });
            }, 500);
        }

        handleBlogPostsLoad({ data, callback }){
            if(data.type !== 'article') return;

            this.pendingRequestUrl = data.url;
            const currentUrl = data.url || this.pendingRequestUrl;

            setTimeout(() => {
                this.renderContent({
                    requestUrl: `${currentUrl}`,
                    callback: this.loadBlogPostsContent({
                        callback: callback
                    })
                });
            }, 500);
        }

        renderContent({ requestUrl, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

             fetch(requestUrl, { signal: this.abortController.signal })
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');
                    callback(html);
                })
                .catch(error => {
                    if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        loadBlogPostsContentByNumber({ callback }){
            return (html) => {
                const blogPostsWrapper = html.querySelector(`.blog-posts[data-id="${this.id}"]`);
                this.blogPostList = this.querySelector(".blog-posts__content");
                 if(blogPostsWrapper){
                    const blogPostList = blogPostsWrapper.querySelector(".blog-posts__content");
                    if(blogPostList){
                        Array.from(blogPostList.children).forEach(child => {
                            this.blogPostList.appendChild(child.cloneNode(true));
                        });

                        this.blogPostList.innerHTML = blogPostList.innerHTML;

                        onVisibilityChange();
                        
                        const pagination = html.querySelector("number-pagination");
                        if(pagination){
                            callback(pagination);
                        }
                    }
                }
            }
        }

        loadBlogPostsContent({ callback }){
            return (html) => {
                const blogPostsWrapper = html.querySelector(`.blog-posts[data-id="${this.id}"]`);
                this.blogPostList = this.querySelector(".blog-posts__content");
                if(blogPostsWrapper){
                    const blogPostList = blogPostsWrapper.querySelector(".blog-posts__content");
                    if(blogPostList){
                        Array.from(blogPostList.children).forEach(child => {
                            this.blogPostList.appendChild(child.cloneNode(true));
                        });
                    }

                    const autoPagination = blogPostsWrapper.querySelector("auto-pagination");
                    if(autoPagination){
                        const url = autoPagination.dataset.url;
                        callback(url);
                    }
                }
            }
        }
        
    }

    customElements.define('blog-posts', BlogPosts);
}